import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { prop } from 'js/utils/ramda.util';
import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector, usePageSelector } from 'js/store/hooks';

import * as actions from './store/actions';

export const useNavigateToPopupBackgroundPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const rootPage = useAppSelector(prop('rootPage'));
    const popupBackgroundPagePath = usePageSelector(prop('popupBackgroundPagePath'));

    return useCallback(() => {
        navigate(popupBackgroundPagePath || rootPage);
        dispatch(actions.clearPageInPopup());
    }, [popupBackgroundPagePath, rootPage, navigate, dispatch]);
};
